import * as marietta from '../../..';
import { SITE_INPUT_MODE } from '../../Constants';
import { SVGSprite } from '../../flash/display';

class SiteLine {
    _firstDot: marietta.core.Point;

    get firstDot() { return this._firstDot; }

    set firstDot(_dot) {
      this._firstDot = _dot;
      this.updateTransforms();
    }

    _secondDot: marietta.core.Point;

    get secondDot() { return this._secondDot; }

    set secondDot(_dot) {
      this._secondDot = _dot;
      this.updateTransforms();
    }

    _locked: boolean = false;

    get locked() { return this._locked; }

    set locked(value: boolean) {
      this._locked = value;
    }

    index: number;

    public spt: SVGSprite;

    public partnerText: marietta.webcad.item.parts.SiteText;

    public parent: marietta.webcad.item.Site;

    public partnerRoad: marietta.webcad.item.parts.SiteRoad;

    /**
     * コンストラクタ
     * */
    constructor(targetNode: Element, id: number) {
      this.index = id;
      // ラインの作成
      const viewObj: SVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      viewObj.setAttribute('stroke', '#3598DC');
      viewObj.setAttribute('stroke-width', '0');
      viewObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(10, 10)));
      viewObj.setAttribute('id', `site_line_${id}`);
      this.spt = new SVGSprite(viewObj);

      targetNode.appendChild(viewObj);
    }

    /**
     * Translateのアップデート
     */
    updateTransforms() {
      if (this.firstDot === undefined || this.secondDot === undefined) return;
      this.viewObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(this.firstDot.x, this.firstDot.y), new marietta.core.Point(this.secondDot.x, this.secondDot.y)));
    }

    /**
     * HTMLElementの取得
     */
    public get viewObj(): HTMLElement {
      return this.spt.element;
    }

    /**
     * ハイライト
     * */
    highlight(value: boolean) {
      this.viewObj.setAttribute('stroke', '#3598DC');
      if (value) {
        this.viewObj.setAttribute('stroke-width', '10');
      } else {
        this.viewObj.setAttribute('stroke-width', '0');
        if (this.parent.inputMode === SITE_INPUT_MODE.SITE_DETAILED_INPUT_MODE) {
          this.viewObj.setAttribute('stroke', '#e6e6e6');
          this.viewObj.setAttribute('stroke-width', '1');
        }
      }
    }

    /**
     * 表示ON
     */
    show() {
      this.spt.element.style.visibility = 'visible';
    }

    /**
     * 表示ON
     */
    hide() {
      this.spt.element.style.visibility = 'hidden';
    }

    showTriangularSideLine() {
      this.spt.element.style.visibility = 'visible';
      this.viewObj.setAttribute('stroke-width', '1');
      this.viewObj.setAttribute('stroke', '#e6e6e6');
    }
}
export default SiteLine;
